import React from 'react';
import Handle from './Handle';

const SaveHandle = props => /*#__PURE__*/React.createElement(Handle, props, "Save");

export default SaveHandle;